import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { BodyM, BodyS, BodySBold, HeadingLBold } from 'components/Typography/Typography';
import { CheckCircleOutline } from '@material-ui/icons';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import styles from 'assets/jss/material-dashboard-pro-react/components/statusDialogStyle.js';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';

interface IStatusDialog {
	isModalOpen: boolean;
	closeModal: Function;
	heading: string;
	desc: string;
	status: string;
	referenceNumber?: string;
	desc2?: string;
	footer?: string;
	ticketId?: string
}
// @ts-ignore
const useStyles = makeStyles(styles);
const StatusDialog = ({
	isModalOpen,
	closeModal,
	heading,
	desc,
	status,
	referenceNumber = '',
	ticketId,
	desc2,
	footer,
}: IStatusDialog) => {
	const classes = useStyles();
	return (
		<CustomDialog
			isOpen={isModalOpen}
			width={500}
			hideDialog={() => closeModal()}
			headerWithIcon={
				status == 'success' ? (
					<div className={classes.iconWrapper}>
						<CheckCircleOutline data-testid="success-icon" className={classes.successIcon} />
					</div>
				) : (
					<div className={classes.iconWrapper}>
						<CancelOutlinedIcon className={classes.failureIcon} data-testid="error-icon" />
					</div>
				)
			}
			dialogBody={
				<div className={classes.modalWrapper}>
					<HeadingLBold>{heading}</HeadingLBold>
					<div className={classes.modalBody}>
						{ticketId && <BodyM className={classes.statusText}>{`${ticketId}`}</BodyM>}
						<BodyM className={classes.statusText}>{`${desc}`}</BodyM>
						{referenceNumber && (
							<div className={classes.refNumberWrapper}>
								<BodyS>{translate('mb.thankyou.ref')}</BodyS>
								<BodySBold>{referenceNumber}</BodySBold>
							</div>
						)}
						<BodyM className={classes.statusText}>{`${desc2}`}</BodyM>
						<BodyM className={classes.statusText}>{`${footer}`}</BodyM>
					</div>
				</div>
			}
		/>
	);
};

export default StatusDialog;
